// extracted by mini-css-extract-plugin
export var container = "coloredZone-module--container--1wNAw";
export var wrapper = "coloredZone-module--wrapper--2ntTE";